import React, { useState, useEffect } from 'react'
import api from '../components/api'
import InputMask from 'react-input-mask';
import { validaCPF } from '../components/functions'
import ModalSenha from '../modals/senha'

const Modal = (props) => {

    var login_id = props.login_id

    
    var ad_usr = sessionStorage.getItem('us_codigo')
    var adesao_institucional_id = props.adesao_institucional_id
    

    var [nome, setNome] = useState()
    var [novoRegistro, setNovoRegistro] = useState(false)
    var [cpf, setCPF] = useState()
    var [dataCriacao, setDataCriacao] = useState()
    var [dataAtualizacao, setDataAtualizacao] = useState()
    var [bloqueado, setBloqueado] = useState(false)
    
    var [email, setEmail] = useState('')
    var [telefone, setTelefone] = useState('')

    var [senha, setSenha] = useState('')
    var [confirmaSenha, setConfirmaSenha] = useState('')
    var [perfil, setPerfil] = useState('')
    

    var [resultadoLoginDesafios, setResultadoLoginDesafios] = useState()


    const salvaLoginDesafioPerm = (desafio_id, loginDesafio_id, permissao) => {


        var dataPost = {

            desafio_id: desafio_id,
            permissao: permissao,
            loginDesafio_id: loginDesafio_id,
            adesao_institucional_id: adesao_institucional_id,

        }


        api.post(`loginDesafioPerm/${login_id}`, dataPost).then((result) => {
        
            //console.log(result.data)
            //window.toastr.success('Registro salvo com sucesso!')
            //carregaLoginDesafio()

        }).catch((err) => {

            console.log(err.response)

        })


    }



    async function carregaLoginDesafio() {

        //console.log('!?')


        if (!isNaN(login_id)) {


            await api.get(`loginDesafio/${adesao_institucional_id}/${login_id}`).then((result) => {

                //console.log(result.data)
                setResultadoLoginDesafios(result.data.map((rs) => 

                    <tr>
                        <td>{rs.desafio_descri}</td>
                        <td>
                            <input type="checkbox" onClick={event => salvaLoginDesafio(rs.desafio_id, rs.loginDesafio_id, event.target.checked)} checked={ rs.loginDesafio_id ? true : false} style={{ display: 'none'}} />
                            <select className='form-control' onChange={event => salvaLoginDesafioPerm(rs.desafio_id, rs.loginDesafio_id, event.target.value)} value={ rs.permissao }>

                                <option value="">Nenhuma</option>
                                <option value="R">Leitura</option>
                                <option value="W">Leitura/Escrita</option>

                            </select>
                        </td>
                    </tr>
                
                ))

            }).catch((err) => {

                console.log(err.response)

            })

        }


    }


    async function salvaLoginDesafio(desafio_id, loginDesafio_id, opc) {

        //console.log(desafio_id, opc)

        var dataPost = {

            desafio_id: desafio_id,
            opc: opc,
            loginDesafio_id: loginDesafio_id,

        }


        //console.log(dataPost)
        //return false


        await api.post(`loginDesafio/${login_id}`, dataPost).then((result) => {
        
            //console.log(result.data)
            carregaLoginDesafio()

        }).catch((err) => {

            console.log(err.response)

        })

    }



    async function detalheLogin() {

        if (login_id == 'novo') {


            setNome('')
            setCPF('')
            setDataCriacao('')
            setDataAtualizacao('')
            setBloqueado()
            setNovoRegistro(true)
            setTelefone('')
            setEmail('')
            setBloqueado(false)
            setPerfil('')
            

        } else {

            await api.get(`login/${adesao_institucional_id}/${login_id}`).then((result) => {

                console.log(result.data)
    
                var data = result.data[0]
                var perfilX = data.perfil

                if (perfilX == null) { perfilX = 'U' }
    
                setNome(data.nome)
                setCPF(data.cpf)
                setEmail(data.email)
                setTelefone(data.telefone)
                setDataCriacao(data.dataCriacao)
                setDataAtualizacao(data.dataAtualizacao)
                setBloqueado(data.bloqueado)
                setNovoRegistro(false)
                setPerfil(perfilX)

                
                
    
    
            }).catch((err) => {
    
                console.log(err.response)
    
            })

        }

        

    }


    async function salva() {


        


        if (!validaCPF(cpf.replaceAll('.', '').replaceAll('-',''))) {

            window.toastr.error('<b>CPF</b> inválido!')
            return false

        }

        if (nome == '') {

            window.toastr.error('<b>Nome</b> n&atilde;o pode ficar em branco!')
            return false

        }


        if (perfil == '' || perfil == null) {

            window.toastr.error('<b>Perfil</b> n&atilde;o pode ficar em branco!')
            return false

        }


        if (novoRegistro) {


            if (senha != confirmaSenha) {

                window.toastr.error('Senhas não conferem!')
                return false

            }


        }

        if (email == '' || email == null) {

            window.toastr.error('<b>E-mail</b> não pode ficar em branco!')
            return false
        }

        
        //console.log(novoRegistro)
        //return false


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    //console.log(dataPost)


                    var dataPost = {

                        nome: nome,
                        cpf: cpf.replaceAll('.', '').replaceAll('-',''),
                        bloqueado: bloqueado,
                        
                        adesao_institucional_id: adesao_institucional_id,
                        ad_usr: ad_usr,
                        telefone: telefone,
                        email: email,
                        perfil: perfil,

                    }


                    if (novoRegistro) {


                        api.post('login', dataPost).then((response) => {
                            console.log(response.data)

                            window.toastr.success('Salvo com sucesso!')
                            props.logins()
                            window.$("#modalLoginAdesaoInstitucional").modal('hide');


                        }).catch((err) => {
                            console.log(err.response)
                        })



                    } else {




                        api.put(`login/${login_id}`, dataPost).then((response) => {
                            console.log(response.data)

                            window.toastr.success('Salvo com sucesso!')
                            props.logins()
                            window.$("#modalLoginAdesaoInstitucional").modal('hide');


                        }).catch((err) => {
                            console.log(err.response)
                        })


                    }
                    

                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }


    useEffect(() => {

        //props.listaLogins()

        detalheLogin()
        carregaLoginDesafio()

        window.$('.nav-tabs a[href="#tabL1"]').tab('show');


    }, [login_id])


    return (

        <div>


                <div className="modal fade" id="modalLoginAdesaoInstitucional" tabindex="-1" role="dialog">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Login</h1>
                            </div>
                            <div class="modal-body">

                                

                            <ul class="nav nav-tabs">
                                <li class="active"><a href="#tabL1" data-toggle="tab">Cadastro</a></li>
                                <li style={{ display: !isNaN(login_id) ? 'table-row' : 'none' }}><a href="#tabL2" data-toggle="tab"  onClick={() => carregaLoginDesafio()}>Responsável por desafios</a></li>
                                
                            </ul>
                            
                            <div class="tab-content">
                                <div class="tab-pane fade in active" id="tabL1">


                                <div class="panel-body">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>CPF</label>
                                                <InputMask mask="999.999.999-99" class="form-control" placeholder="" value={cpf} onChange={event => setCPF(event.target.value)} />
                                                                
                                            </div>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <label>Nome</label>
                                                <input type="text" class="form-control" placeholder="" value={nome} onChange={event => setNome(event.target.value)} />
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <label>E-mail</label>
                                                <input type="text" class="form-control" placeholder="" value={email} onChange={event => setEmail(event.target.value)} />
                                                                
                                            </div>
                                        </div>


                                        <div class="col-md-3" style={{ display: 'none'}}>
                                            <div class="form-group">
                                                <label>Perfil</label>
                                                <select class="form-control" placeholder="" value={perfil} onChange={event => setPerfil(event.target.value)} >

                                                    <option value="">[Selecione]</option>
                                                    <option value="U">Usuário</option>
                                                    <option value="A">Administrador</option>

                                                </select>
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label>Telefone</label>
                                                <InputMask mask="(99) 99999-9999" class="form-control" placeholder="" value={telefone} onChange={event => setTelefone(event.target.value)} />
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-4" style={{ display: novoRegistro ? 'none' : 'table-row'}}>
                                            <div class="form-group">
                                                <label>Criado em</label>
                                                <input type="text" class="form-control" placeholder="" value={dataCriacao} readOnly tabIndex={-1} />
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-4" style={{ display: novoRegistro ? 'none' : 'table-row'}}>
                                            <div class="form-group">
                                                <label>Última alteração em</label>
                                                <input type="text" class="form-control" placeholder="" value={dataAtualizacao} readOnly tabIndex={-1}  />
                                                                
                                            </div>
                                        </div>


                                        <div class="col-md-4" style={{ display: novoRegistro ? 'table-row' : 'none'}}>
                                            <div class="form-group">
                                                <label>Senha</label>
                                                <input type="password" class="form-control" placeholder="" value={senha} onChange={event => setSenha(event.target.value)}  />
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-4" style={{ display: novoRegistro ? 'table-row' : 'none'}}>
                                            <div class="form-group">
                                                <label>Confirma senha</label>
                                                <input type="password" class="form-control" placeholder="" value={confirmaSenha} onChange={event => setConfirmaSenha(event.target.value)} />
                                                                
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Bloqueado</label>
                                                <select class="form-control" value={bloqueado} onChange={event => setBloqueado(event.target.value)}>
                                                    <option value={false}>Não</option>
                                                    <option value={true}>Sim</option>
                                                </select>
                                                                
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div class="tab-pane fade" id="tabL2">

                                    

                                    <table id="dataTableDesafios" className="table table-bordered table-striped table-hover">
                                        <thead>
                                            <tr>                                                
                                            <th align={'center'}>Desafio</th>
                                            <th width={'20%'} align={'center'}><center>Responsável</center></th>
                                            
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {resultadoLoginDesafios}
                                        </tbody>
                                    </table>


                                </div>

                            </div>




                                    
                                    


                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-dismiss="modal">Fechar</button>
                                <button type="button" className="btn btn-warning" data-toggle="modal" data-target="#modalAlteraSenha" style={{ display: login_id ? 'table-row' : 'none' }} >Alterar Senha</button>
                                <button type="button" className="btn btn-success" onClick={() => salva()}>Salvar</button>
                            </div>
                        </div>
                    </div>
                </div>

            <ModalSenha login_id={login_id} />

        </div>


    )

}


export default Modal
